import util from '../util'

let controller = 'AuditTrail'
export default Object.assign({}, util.GetCrud(controller, null), {
    ComboEntidades: function () {
        return util.Axios.Get(controller + '/ComboEntidades');
    },
    ComboOperadores: function () {
        return util.Axios.Get(controller + '/ComboOperadores');
    }
})
